import { computed, ref } from "vue";
import type { ContentDetailAPIResponse } from "~/models/content-detail-api-response";
import {
  fetchContentDetails,
  FetchContentStatus,
} from "~/services/content-detail-service";

// TODO - composable should not do this, we should pass the data and then we just render state, text here
export const useContentDetail = async (contentId: string) => {
  const loading = ref(false);
  const data = ref<ContentDetailAPIResponse | null>(null);
  const status = ref<FetchContentStatus | null>(null);

  const imageUrl = import.meta.env.VITE_IMAGE_URL;

  // TODO - we need to run this func everytime we test, maybe this function under useContentDetail() is not a good idea
  async function loadContentDetails() {
    loading.value = true;

    const result = await fetchContentDetails(contentId);
    // TODO - data.value should never null, if null --> it should error
    data.value = result.data;
    status.value = result.status;

    loading.value = false;
  }

  const galleryImageUrls = computed(() => {
    return data.value?.galleries?.length
      ? data.value.galleries.map((imageName) => `${imageUrl}${imageName}`)
      : [`${imageUrl}${data.value?.article_image}`];
  });

  const isLoading = computed(() => loading.value);
  const isError404 = computed(
    () => status.value === FetchContentStatus.NOT_FOUND,
  );
  const isOtherError = computed(
    () => status.value === FetchContentStatus.ERROR,
  );

  // Use ?? "" to ensure these variable below always return strings for process next
  const titleTh = computed(() => data.value?.title_th ?? "");
  const descriptionTh = computed(() => data.value?.description_th ?? "");
  const publishDate = computed(() => data.value?.publish_date);
  const contentType = computed(() => data.value?.type);
  const jwLink = computed(() => data.value?.jw_media_id ?? "");
  const bannerImage = computed(
    () => `${imageUrl}${data.value?.banner_image ?? ""}`,
  );

  const truncatedTitle = computed(() => trimString(titleTh.value, 60));
  const truncatedDescription = computed(() =>
    trimString(descriptionTh.value, 160),
  );

  await loadContentDetails();

  return {
    isLoading,
    isError404,
    isOtherError,
    titleTh,
    descriptionTh,
    publishDate,
    galleryImageUrls,
    contentType,
    jwLink,
    bannerImage,
    truncatedTitle,
    truncatedDescription,
  };
};
